import { HStack, Link, Text, VStack } from '@direct-frontend/components';
import { Drawer, DrawerBottomFixed, DrawerButton, DrawerHeader, type DrawerProps } from '@/shared/components/Drawer';
import styles from './AliceRelatedServicesModal.module.css';

export const AliceRelatedServicesModal = (props: DrawerProps) => (
    <Drawer snapPoints={[1]} {...props}>
        <VStack className={styles.root}>
            <DrawerHeader title="Описание услуги" />

            <VStack className={styles.container}>
                <VStack>
                    <Text bold className={styles.title}>
                        Подключение и настройка от мастера-партнёра Яндекса
                    </Text>

                    <ul className={styles.list}>
                        <li>Консультация бесплатно</li>
                        <li>Монтаж и настройка за 2 часа</li>
                        <li>Уборка после установки</li>
                        <li>Гарантия 1 год</li>
                    </ul>
                </VStack>

                <VStack>
                    <Text bold className={styles.title}>
                        Процесс установки:
                    </Text>

                    <ol className={styles.list}>
                        <li>Оставляете заявку и оплачиваете заказ</li>
                        <li>Мастер связывается, уточняет детали, выбираете дату и время</li>
                        <li>Оплачиваете выбранные услуги</li>
                        <li>Приезжает мастер - монтирует и настраивает</li>
                    </ol>
                </VStack>

                <VStack>
                    <Text bold className={styles.title}>
                        Стоимость установки:
                    </Text>

                    <ul className={styles.list}>
                        <li>Установка карниза — 1 ₽</li>
                        <li>Снять старый карниз — 1000 ₽</li>
                        <li>Снять шторы — 1500 ₽</li>
                    </ul>
                </VStack>

                <Link
                    href="https://smarthome-service.ru/calculator?items=curtain-slide-s%3A1&promo=true"
                    target="_blank"
                >
                    <Text size="mc" className={styles.link}>
                        Калькулятор стоимости
                    </Text>
                </Link>

                <HStack gap="4">
                    <Text size="mc" role="supplementary">
                        Оставляя заявку, вы соглашаетесь с
                    </Text>
                    <Link href="https://yandex.ru/legal/site_terms/ru/" target="_blank">
                        <Text size="mc" role="supplementary" className={styles.link}>
                            правилами
                        </Text>
                    </Link>
                </HStack>

                <Text size="mc">
                    Обратите внимание: услуга предоставляется только в Москве, Санкт-Петербурге, Московской и
                    Ленинградской областях.
                </Text>
            </VStack>
        </VStack>

        <VStack className={styles.button}>
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose} type="secondary">
                    Хорошо
                </DrawerButton>
            </DrawerBottomFixed>
        </VStack>
    </Drawer>
);
